// @ts-nocheck

import React from 'react';

import Link from '../../../../components/Link';
import { __ } from '../../../../i18n/l10n';

import { Bloc, Span, ArrowPrevious } from './common';

type Props = {
  className?: string;
};

const GridsHistoryBackButtonDesktop = ({ className }: Props) => {
  return (
    <Link to="/grilles/history" className={className}>
      <Bloc>
        <ArrowPrevious />
        <Span>{__('Back')}</Span>
      </Bloc>
    </Link>
  );
};

export default GridsHistoryBackButtonDesktop;
